var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('div',{staticClass:"copyright"},[_c('strong',[_vm._v("Copyright © "+_vm._s(new Date().getFullYear())+" "),_c('a',{attrs:{"href":"#"}},[_vm._v(_vm._s(_vm.appInfo.company ? _vm.appInfo.company :'CloudGo'))]),_vm._v(".")]),_vm._v(" All rights reserved.")])])
}
var staticRenderFns = []

export { render, staticRenderFns }